/**
 * floating-atc.js
 * Floating Add-to-Cart bar for product pages.
 * Upload this file to: Shopify Admin > Themes > Assets
 */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-product')) return;

  const buttons = document.querySelector('.product-actions');
  if (!buttons) return;

  const form = buttons.closest('form');

  const floating = document.createElement('div');
  document.body.appendChild(floating);

  function positionFloating() {
    const rect = buttons.getBoundingClientRect();
    floating.style.cssText = [
      'position:fixed',
      'bottom:20px',
      'left:' + rect.left + 'px',
      'width:' + rect.width + 'px',
      'z-index:9999',
      'background:#ffffff',
      'border-radius:12px',
      'box-shadow:0 4px 16px rgba(0,0,0,0.15)',
      'display:none',
      'pointer-events:auto',
      'box-sizing:border-box',
      'padding:12px',
    ].join(';');
  }

  function buildFloating() {
    floating.innerHTML = '';

    const addToCartRow = buttons.querySelector('.product-actions-add-to-cart');
    if (addToCartRow) {
      const row = addToCartRow.cloneNode(true);
      row.style.cssText = 'width:100%;box-sizing:border-box;display:flex;';

      const qty = row.querySelector('.quantity-input');
      if (qty) qty.style.cssText = 'flex-shrink:0;width:120px;';

      const btn = row.querySelector('button[type="submit"]');
      if (btn) {
        btn.style.cssText = 'flex:1;box-sizing:border-box;';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          form.querySelector('button[type="submit"]').click();
        });
      }

      floating.appendChild(row);

      // Sync quantity between static and floating inputs
      const staticQty = buttons.querySelector('.quantity-input-field');
      const floatingQty = row.querySelector('.quantity-input-field');
      if (staticQty && floatingQty) {
        floatingQty.value = staticQty.value;
        staticQty.addEventListener('input', function () {
          floatingQty.value = staticQty.value;
        });
        floatingQty.addEventListener('input', function () {
          staticQty.value = floatingQty.value;
        });
      }
    }

    // Buy Now / Shop Pay button
    const buyNowContainer = buttons.querySelector('.product-actions-buy-now');
    const shopifyComponent =
      buyNowContainer && buyNowContainer.querySelector('shopify-accelerated-checkout');
    if (shopifyComponent) {
      const buyNowWrapper = document.createElement('div');
      buyNowWrapper.style.cssText = 'width:100%;box-sizing:border-box;margin-top:8px;';
      buyNowWrapper.innerHTML =
        '<button style="width:100%;background:#5a31f4;color:#fff;border:none;border-radius:4px;padding:14px;font-size:15px;font-weight:600;cursor:pointer;box-sizing:border-box;">Buy with Shop Pay</button>';

      buyNowWrapper.querySelector('button').addEventListener('click', function () {
        floating.style.display = 'none';
        buttons.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () {
          shopifyComponent.click();
        }, 600);
      });

      floating.appendChild(buyNowWrapper);
    }
  }

  // Rebuild floating bar if product form content changes (e.g. variant switch)
  const observer = new MutationObserver(buildFloating);
  observer.observe(buttons, { childList: true, subtree: true });

  buildFloating();
  positionFloating();
  window.addEventListener('resize', positionFloating);

  window.addEventListener('scroll', function () {
    const rect = buttons.getBoundingClientRect();
    if (rect.bottom < 0) {
      const staticQty = buttons.querySelector('.quantity-input-field');
      const floatingQty = floating.querySelector('.quantity-input-field');
      if (staticQty && floatingQty) {
        floatingQty.value = staticQty.value;
        if (!floatingQty.dataset.synced) {
          floatingQty.dataset.synced = 'true';
          floatingQty.addEventListener('input', function () {
            staticQty.value = floatingQty.value;
          });
          floatingQty.addEventListener('change', function () {
            staticQty.value = floatingQty.value;
          });
        }
      }
      floating.style.display = 'block';
    } else {
      floating.style.display = 'none';
    }
  });
});
